import config from "@/config";
export default {
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    query() {
      return this.$store.state.query;
    },
    userid() {
      return this.$store.state.userid;
    },
    serverUrl() {
      return config.serverUrl;
    },
    liffid() {
      return config.liffid;
    },
    headers() {
      return config.headers;
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      let w = window.innerWidth;
      let h = window.innerHeight;
      if (this.$store) {
        if (w !== this.$store.state.windowW) {
          this.$store.state.windowW = window.innerWidth;
          this.$store.state.windowH = window.innerHeight;

          // console.log(w);
          if (w < 600) {
            this.$store.state.dpSize = "xs";
          } else if (w > 600 && w < 960) {
            this.$store.state.dpSize = "sm";
          } else if (w > 960 && w < 1280) {
            this.$store.state.dpSize = "md";
          } else if (w > 1280 && w < 1920) {
            this.$store.state.dpSize = "lg";
          } else if (w > 1920 && w < 2560) {
            this.$store.state.dpSize = "xl";
          }
        }
      }
    },
  },
};
